import script from "./CxLogout.vue?vue&type=script&lang=ts"
export * from "./CxLogout.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__